import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { mdiAccount } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const EmptyUser = () => {
  const { classes, theme } = useStyles();

  return (
    <Box className={classes.emptyUser} data-testid="no-users">
      <MiIcon
        path={mdiAccount}
        color={theme.palette.grey.darkerAccent}
        size={1.2}
      />
      <Typography fontWeight={theme.fontWeight.medium}>
        Add Technicians
      </Typography>
      <Typography
        variant={TYPOGRAPHY_VARIANTS.BODY2}
        color={theme.palette.grey.darkerAccent}
      >
        No technicians added yet. Start adding technicians from your list.
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  emptyUser: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.background.default,
  },
}));
